import React, { useContext } from 'react';
import { Grid, GridApi } from '@instinet-analytics/semantic-ui-components';
import { GetRowClassParams } from '@instinet-analytics/semantic-ui-components';
import { StrategyParametersRowData } from './gridData';
import { strategyParamColDefs } from './strategyParametersColumns';
import AppContext from 'app/AppContext';

interface StrategyParametersGridProps {
    height: number;
    rowData: StrategyParametersRowData[];
    searchText?: string;
    onGridApiSet: (gridApi: GridApi) => void;
}

export default function StrategyParametersGrid(
    props: StrategyParametersGridProps
) {
    const { height, rowData, onGridApiSet } = props;

    const appContext = useContext(AppContext);

    const colDefs = strategyParamColDefs(appContext);

    const onGridReady = (api: GridApi) => {
        onGridApiSet(api);
    };

    const getRowDataId = (d: StrategyParametersRowData) => d.name;
    const rowClassRules = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'new-or-updated-row': (
            d: GetRowClassParams<StrategyParametersRowData>
        ) => !!d.data.newValue,
    };

    return (
        <div className="StrategyParametersGrid" style={{ height }}>
            <Grid
                columnDefs={colDefs}
                getRowDataId={getRowDataId}
                rowData={rowData}
                rowClassRules={rowClassRules}
                onGridReady={onGridReady}
            />
        </div>
    );
}
